import { createAction, props } from '@ngrx/store';
import { HeatLoadCalculationMethod } from '@customer-apps/shared/enums';
import { AppSpecificDataState } from '@customer-apps/shared/interfaces';

export namespace AppSpecificDataActions {
    export const setAppSpecificData = createAction('[APP SPECIFIC DATA] Set App Specific Data', props<AppSpecificDataState>());
    export const addHeatloadCalculation = createAction(
        '[APP SPECIFIC DATA] Add Heatload Calculation',
        props<{ method: HeatLoadCalculationMethod; calculation: object }>()
    );
    export const removeHeatloadCalculation = createAction(
        '[APP SPECIFIC DATA] Remove Heatload Calculation',
        props<{ method: HeatLoadCalculationMethod }>()
    );
    export const removeAllHeatloadCalculations = createAction('[APP SPECIFIC DATA] Remove Heatload Calculations');
}
